import React from 'react'

function WeeklyScheduleList({ handleRemoveSchedule, weeklySchedule, handleAddTime }) {
  return (
    <div className="weekly-schedule">
        <h4 className="section-title">Weekly Schedule</h4>
        <div className="schedule-table">
            {weeklySchedule.map((day, index) => (
            <div className="schedule-row" key={index}>
                <div className="day-circle">
                <span className={day.times.length > 0 ? 'active' : ''}>
                    {day.day}
                </span>
                </div>
                <div className="time-slots">
                {day.times.length > 0 ? (
                    day.times.map((time, timeIndex) => (
                    <div className="time-slot" key={timeIndex}>
                        {time}
                        <button
                            className="btn-remove"
                            onClick={() => handleRemoveSchedule(index, timeIndex)}
                        >
                        ×
                        </button>
                    </div>
                    ))
                ) : (
                    <span className="no-schedule">Not Scheduled</span>
                )}
                </div>
                <button 
                className="btn-add"
                onClick={() => handleAddTime(index)}
                >
                +
                </button>
            </div>
            ))}
        </div>
    </div>
  )
}

export default WeeklyScheduleList
